import 'bxcommon/validations/inityup';

import { createRoot } from 'react-dom/client';

import i18n from 'bxcommon/i18n';
import * as common from 'bxcommon/locales/en/common';

import * as en from './locales/en';
import App from './App';

const resources = {
  en: {
    common: common.default,
    prospectus: en.default,
  },
};

i18n.init({
  resources,
  lng: 'en',
  ns: ['common', 'prospectus'],
  defaultNS: 'prospectus',
  interpolation: {
    escapeValue: false,
  },
});

createRoot(document.getElementById('root')).render(<App />);
